
<div :class="[classes(n('--content')), classes(n(`--content--default`))]">
  <div
    v-for="(keysSetting, i) in chunkedSetting"
    :key="`keyboard-column-${i}`"
    :class="[classes(n(`--content--default--item`))]"
  >
    <div
      v-for="item in keysSetting"
      :key="item.key"
      :class="[n(`--content--default--item--split`)]"
    >
      <KeyboardItem
        :class="[n(`--content--default--item--key`), item.className ? n(`--content--item--${item.className}`) : '']"
        :value="item.key"
        :safe-mode="safeMode"
        :confirm-btn-text="confirmBtnText"
        @click="handleClick"
      />
    </div>
  </div>
</div>
